import { cssUtil } from "../utils/cssUtil.js";
import { getBaseStyles, renderBackground } from "./commonStyles.js";

export async function renderContainerWidget(context, widget, parent) {

    const el = context.document.createElement("div");
    el.classList.add("widget", "container_widget");

    const breakpoint = context.currentBreakpoint;
    const border = widget?.properties?.desktop?.border;    

    const styles = {
        ...getBaseStyles(widget, breakpoint),
        ...applyBorderStyles(border)
    };

    el.setAttribute("style", cssUtil.toStyleString(styles));
    el.setAttribute("data-widgetId", widget.uid);
    el.setAttribute("data-widgetType", widget.type);
    el.setAttribute("data-widgetParent", widget.parent);

    parent.appendChild(el);

    renderContainerBackground(context, widget, el);

    const children = context.widgets.filter(w => w.parent === widget.uid);
    if (!children || children.length === 0) {
        return;
    }

    for (const child of children) {
        const device = child?.properties?.[breakpoint];
        if (device?.visible === false) continue;

        const renderer = context.renderers[child.type];
        if (!renderer) continue;

        await renderer(context, child, el);
    }
    return el;
}

function renderContainerBackground(context, widget, element) {
    const props = widget?.properties?.desktop;
    if (!props?.background) return;

    renderBackground(context, widget, element);
}

function applyBorderStyles(border) {

    const styles = {};
    
    if (!border) return;

    const radius = border.radius;
    if (radius) {
        if (radius.topLeft) styles["border-top-left-radius"] = `${radius.topLeft}px`;
        if (radius.topRight) styles["border-top-right-radius"] = `${radius.topRight}px`;
        if (radius.bottomRight) styles["border-bottom-right-radius"] = `${radius.bottomRight}px`;
        if (radius.bottomLeft) styles["border-bottom-left-radius"] = `${radius.bottomLeft}px`;
    }

    const colorProp = border.color;
    if (colorProp) {
        if (colorProp.type === "gradient") {
            styles["border-image"] = cssUtil.getCssGradient(colorProp);
        } else {
            styles["border-color"] = cssUtil.getCssColor(colorProp);
        }
    }

    const width = border.width;
    let borderWidth = parseInt(width || 0, 10);

    if (width) {
        if (border.style === "all") {
            styles["border-width"] = `${width}px`;
            borderWidth *= 2;
        } else {
            styles["border-width"] = `${width}px`;
            styles["border-style"] = 'solid';
        }
    }

    return styles;
}